// The connect form's porthole loop (prototype avatar D, nodding). Names carry a content hash.
export const PORTHOLE_VIDEO = {
  poster: "/media/avatar-d-nod.9376fe6d36.jpg",
  webm: "/media/avatar-d-nod.39ca6baade.webm",
  mp4: "/media/avatar-d-nod.704d84fad4.mp4",
} as const;
